import { render, staticRenderFns } from "./UrlEditorFeature.vue?vue&type=template&id=45d680da&scoped=true&"
import script from "./UrlEditorFeature.vue?vue&type=script&lang=js&"
export * from "./UrlEditorFeature.vue?vue&type=script&lang=js&"
import style0 from "./UrlEditorFeature.vue?vue&type=style&index=0&id=45d680da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d680da",
  null
  
)

export default component.exports